/**
 * Drobnosti pro dotyk (iPhone, iPad), které samo CSS neumí: vodorovně posuvné řádky filtrů
 * a záložek (Doklady, Přehledy, Weby, stav zakázky…) drží vybranou položku v záběru.
 * - klepnutí na napůl schovanou položku ji dorolují celou do řádku
 * - když se vybraná položka změní (načtení stránky, odkaz s ?tab=), řádek k ní skočí
 * Roluje se jen samotný řádek, nikdy celá obrazovka.
 */

const SCROLLER = '.chips, .ws-tabs, .ws-sites, .job-steps, [role="tablist"]';
const ACTIVE = '.on, [aria-selected="true"], [aria-pressed="true"]';
const EDGE = 24;

function scrollsSideways(el: HTMLElement): boolean {
  if (el.scrollWidth <= el.clientWidth + 2) return false;
  const ox = getComputedStyle(el).overflowX;
  return ox === 'auto' || ox === 'scroll';
}

function reveal(item: Element, smooth: boolean): void {
  const box = item.closest<HTMLElement>(SCROLLER);
  if (!box || !scrollsSideways(box)) return;
  const b = box.getBoundingClientRect();
  const r = item.getBoundingClientRect();
  const behavior: ScrollBehavior = smooth ? 'smooth' : 'auto';
  if (r.left < b.left + 4) box.scrollBy({ left: r.left - b.left - EDGE, behavior });
  else if (r.right > b.right - 4) box.scrollBy({ left: r.right - b.right + EDGE, behavior });
}

const lastActive = new WeakMap<Element, Element>();

function syncActive(): void {
  for (const box of document.querySelectorAll<HTMLElement>(SCROLLER)) {
    const active = box.querySelector(ACTIVE);
    if (!active || lastActive.get(box) === active) continue;
    lastActive.set(box, active);
    reveal(active, false);
  }
}

let installed = false;

export function installTouchHelpers(): void {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    const item = target?.closest('button, a, [role="tab"]');
    if (!item?.closest(SCROLLER)) return;
    // až po překreslení (položka mohla změnit šířku, když se stala vybranou)
    requestAnimationFrame(() => reveal(item, true));
  });
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      syncActive();
    });
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'aria-selected', 'aria-pressed'],
  });
}
